import styled from "styled-components";
import { ModalContainer } from "../../components/Modal/styled";
import { WrapperContainer } from "../../components";
import { colors } from "../../consts";

export const LicensesModalContainer = styled(ModalContainer)`
  max-width: 90vw;
`;

export const LicensesSection = styled(WrapperContainer)`
  padding-top: 24px;
  border-top: 1px solid ${colors.RAISIN_10};
`;

export const Cell = styled.td`
  overflow-wrap: anywhere;
`;
